export default __webpack_public_path__ + "static/media/code-o.f1465162.svg";